import { useContext, useEffect, useState } from "react";
import { SectionGraphContext } from "../SectionGraph";
import SimpleBarChart from "./GraphTypes/SimpleBarChart";
import SimpleLineChart from "./GraphTypes/SimpleLineChart";
import SimplePieChart from "./GraphTypes/SimplePieChart";
import SmetaTabs from "../../../../Tools/Tabs/SmetaTabs";
import { SmetaTabItem } from "../../../../Tools/Tabs/PinIcons";

export interface Series {
  label: string;
  data: number[];
}
export interface XAxis {
  data: string[];
  scaleType: string;
}

interface ChartData {
  series: Series[];
  xAxis: XAxis[];
}

interface Chart {
  "3D": string;
  Marks: string;
  Type: string;
  items: DataSeries[];
}
interface DataSeries {
  Marks: string;
  Type: string;
  Title: string;
  items: DataPoints[];
}

interface DataPoints {
  Label: string;
  X: string;
  Y: string;
}

const SimpleGraph = () => {
  const context = useContext(SectionGraphContext) || {};
  const { chart } = context;

  const [chartData, setChartData] = useState<ChartData>({ series: [], xAxis: [] });

  useEffect(() => {
    if (chart) setChartData(getChartsData(chart));
  }, [chart]);

  const getChartsData = (data: Chart) => {
    const initAcc: ChartData = { series: [], xAxis: [] };

    return data.items.reduce((acc, item) => {
      const type = item.Type;
      const xAxisData: string[] = [];
      const seriesData = item.items.map((item) => {
        xAxisData.push(item.Label);
        return Number(item.Y);
      });
      const series = { label: item.Title, data: seriesData };
      const xAxis = { data: xAxisData, scaleType: "band" };
      acc.series.push(series);
      acc.xAxis.push(xAxis);
      return acc;
    }, initAcc);
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        maxHeight: "calc(100% - 130px)",
        width: "100%",
        backgroundColor: "#ffffff",
      }}
    >
      <div style={{ display: "flex", flexDirection: "row", flex: "1 1 0" }}>
        <SmetaTabs>
          <SmetaTabItem label="Столбцы">
            <SimpleBarChart series={chartData.series} xAxis={chartData.xAxis} />
          </SmetaTabItem>
          <SmetaTabItem label="Линии">
            <SimpleLineChart series={chartData.series} xAxis={chartData.xAxis} />
          </SmetaTabItem>
          <SmetaTabItem label="Диаграмма">
            <SimplePieChart series={chartData.series} />
          </SmetaTabItem>
        </SmetaTabs>
      </div>
    </div>
  );
};
export default SimpleGraph;
